//@ts-nocheck
/*
@ts-ignore
@ts-nocheck
 */
import axios from "axios";
import _ from "lodash";
import { t } from "i18next";

import AlertsService from "services/alerts-service";

import { mergeStorage, omitStorage } from "hooks/useStorage";

const DormitoriesApi = {
    getMyDormitories: async () => {
        try {
            const { data: response } = (await axios.get("/dormitories/my")) as any;
            mergeStorage(`dormitories`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t('bujbvk1ee54'));
        }
    },
    createDormitory: async () => {
        try {
            const { data: response } = (await axios.post("/dormitories", {})) as any;
            await DormitoriesApi.getMyDormitories();
            return response;
        } catch (error) {
            throw AlertsService.showError(t('ucn98jsft2'));
        }
    },
    updateDormitory: async (data: Object) => {
        try {
            let dd = {...data};
            delete dd.hideFromAll;
            const { data: response } = (await axios.put(`/dormitories`, dd)) as any;
            await DormitoriesApi.getAllDormitories();
            AlertsService.showSuccess(`Общежитие успешно обновлено`);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('oc4wpjt0rro'));
        }
    },
    deleteDormitory: async (id: string) => {
        try {
            await axios.delete(`/dormitories/${id}`);
            omitStorage(`dormitories.${id}`);
            await DormitoriesApi.getMyDormitories();
            AlertsService.showSuccess(`Общежитие успешно удалено`);
        } catch (error) {
            throw AlertsService.showError(t('ztdstxy6d6'));
        }
    },
    getAllDormitories: async () => {
        try {
            const { data: response } = (await axios.get("/dormitories/all")) as any;
            mergeStorage(`dormitories`, _.keyBy(response, `id`));
            return response;
        } catch (error) {
            throw AlertsService.showError(t('vku33272v1'));
        }
    },
    getDormitoryInfo: async (id: string) => {
        try {
            const { data: response } = (await axios.get(`/dormitories/${id}`)) as any;
            mergeStorage(`dormitories.${id}`, response);
            return response;
        } catch (error) {
            throw AlertsService.showError(t('bs6mwijfc6t'));
        }
    },
};

export default DormitoriesApi;
